export default __webpack_public_path__ + "static/media/default-profile-cover.f0c588c5.png";